// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1p4sv","row":"Node_row__2-KVH","label":"Node_label__2M_Rd","footer":"Node_footer__e_PKG"};